import React from 'react';

const XpPointsIcon = () => {
	return (
		<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<circle cx='10' cy='10' r='9' fill='currentColor' fillOpacity='0.18' />
			<circle cx='10' cy='10' r='8.5' stroke='currentColor' strokeWidth='1' />
			<text
				x='10'
				y='12.5'
				textAnchor='middle'
				fontSize='7'
				fontWeight='700'
				fill='currentColor'
				fontFamily='Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
			>
				XP
			</text>
		</svg>
	);
};

export default XpPointsIcon;

